module.exports = __webpack_public_path__ + "static/littleoneplaque-d298f59db1f27bc14f875f189cfe9a8a.png";